import { call, put, takeLatest } from "@redux-saga/core/effects";
import { jarvisPrimeDashboardApis } from "./jarvisPrimeDashboardApis";
import { jarvisPrimeDashboardParsers } from "./jarvisPrimeDashboardParsers";
import { jarvisPrimeDashboardConstants } from "./jarvisPrimeDashboardConstants";
import { tracker } from "library/tracker";
import { jarvisPrimeRmsConstants } from "../jarvisPrimeRms/jarvisPrimeRmsConstants";

function* portfolioAllocationSaga({ type, payload }) {
  try {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALLOCATIONS_REQUEST,
    });
    const res = yield call(jarvisPrimeDashboardApis.getPortfolioAllocations);

    const data = jarvisPrimeDashboardParsers.portfolioAllocation(res);
    let count = 0;
    if (res.count) {
      count = res.count;
    }

    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALLOCATIONS_RESPONSE,
      payload: { data, count },
    });
  } catch (error) {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALLOCATIONS_RESPONSE,
      payload: { data: [], count: 0 },
    });
  }
}

function* portfolioOverviewSaga({ type, payload }) {
  try {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_OVERVIEW_REQUEST,
    });
    const res = yield call(jarvisPrimeDashboardApis.getPortfolioOverview);

    const payload = jarvisPrimeDashboardParsers.portfolioOverview(res);
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_OVERVIEW_RESPONSE,
      payload,
    });
  } catch (error) {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_OVERVIEW_RESPONSE,
      payload: {},
    });
  }
}

function* portfolioPerformanceSaga({ type }) {
  try {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PERFORMANCE_REQUEST,
    });
    const res = yield call(jarvisPrimeDashboardApis.getPortfolioPerformance);
    const payload = jarvisPrimeDashboardParsers.portfolioPerformance(res);
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PERFORMANCE_RESPONSE,
      payload,
    });
  } catch (error) {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PERFORMANCE_RESPONSE,
      payload: {},
    });
  }
}

function* portfolioChartSaga({ type }) {
  try {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_CHART_REQUEST,
    });
    const res = yield call(jarvisPrimeDashboardApis.getPortfolioChart);
    const payload = jarvisPrimeDashboardParsers.portfolioChart(res);
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_CHART_RESPONSE,
      payload,
    });
  } catch (error) {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_CHART_RESPONSE,
      payload: {},
    });
  }
}

function* portfolioSectorSaga({ type }) {
  try {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_SECTOR_REQUEST,
    });
    const res = yield call(jarvisPrimeDashboardApis.getPortfolioSector);
    const payload = jarvisPrimeDashboardParsers.portfolioSector(res);
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_SECTOR_RESPONSE,
      payload,
    });
  } catch (error) {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_SECTOR_RESPONSE,
      payload: [],
    });
  }
}

function* portfolioMarketSaga({ type }) {
  try {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_MARKET_REQUEST,
    });
    const res = yield call(jarvisPrimeDashboardApis.getPortfolioMarket);
    const payload = jarvisPrimeDashboardParsers.portfolioMarket(res);
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_MARKET_RESPONSE,
      payload,
    });
  } catch (error) {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_MARKET_RESPONSE,
      payload: [],
    });
  }
}

function* customerStoriesListSaga() {
  try {
    yield put({ type: jarvisPrimeDashboardConstants.CUSTOMER_STORIES_REQUEST });
    const res = yield call(jarvisPrimeDashboardApis.getCustomerStoriesList);
    const payload = jarvisPrimeDashboardParsers.customerStoryList(res);
    yield put({
      type: jarvisPrimeDashboardConstants.CUSTOMER_STORIES_RESPONSE,
      payload,
    });
  } catch (error) {
    yield put({
      type: jarvisPrimeDashboardConstants.CUSTOMER_STORIES_RESPONSE,
      payload: [],
    });
  }
}

function* welcomeVideoListSaga() {
  try {
    yield put({ type: jarvisPrimeDashboardConstants.WELCOME_VIDEO_REQUEST });
    const res = yield call(jarvisPrimeDashboardApis.getWelcomeVideoList);
    const payload = jarvisPrimeDashboardParsers.welcomeVideoList(res);
    yield put({
      type: jarvisPrimeDashboardConstants.WELCOME_VIDEO_RESPONSE,
      payload,
    });
  } catch (error) {
    yield put({
      type: jarvisPrimeDashboardConstants.WELCOME_VIDEO_RESPONSE,
      payload: [],
    });
  }
}

function* portfolioAlertSaga() {
  try {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALERT_REQUEST,
    });
    const res = yield call(jarvisPrimeDashboardApis.getPortfolioAlert);
    const payload = jarvisPrimeDashboardParsers.portfolioAlert(res);
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALERT_RESPONSE,
      payload,
    });
  } catch (error) {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALERT_RESPONSE,
      payload: {},
    });
  }
}

function* portfolioPendingTransactionSaga() {
  try {
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PENDING_TRANSACTION_REQUEST,
    });

    const res = yield call(
      jarvisPrimeDashboardApis.getPortfolioPendingTransaction,
    );
    //event-tracker: Partial Buy/Sell -> invest_more_now_success
    tracker.partialBuySell.investMoreNowSuccess();

    const payload =
      jarvisPrimeDashboardParsers.portfolioPendingTransaction(res);

    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PENDING_TRANSACTION_RESPONSE,
      payload,
    });
  } catch (error) {
    //event-tracker: Partial Buy/Sell -> invest_more_now_failed
    tracker.partialBuySell.investMoreNowFailed({ error_msg: error.message });
    yield put({
      type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PENDING_TRANSACTION_RESPONSE,
      payload: {},
    });
  }
}

function* dashboardRefreshSaga() {
  yield put({ type: jarvisPrimeRmsConstants.PRIME_RESET_RMS_DATA });
  yield put({
    type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_MARKET_SAGA,
  });
  yield put({ type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_CHART_SAGA });
  yield put({
    type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALLOCATIONS_SAGA,
  });
  yield put({
    type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PERFORMANCE_SAGA,
  });
  yield put({
    type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_SECTOR_SAGA,
  });
  yield put({
    type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_OVERVIEW_SAGA,
  });
  yield put({ type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALERT_SAGA });
}

export function* registerjarvisPrimeDashboardSagas() {
  yield takeLatest(
    jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALLOCATIONS_SAGA,
    portfolioAllocationSaga,
  );
  yield takeLatest(
    jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_OVERVIEW_SAGA,
    portfolioOverviewSaga,
  );
  yield takeLatest(
    jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PERFORMANCE_SAGA,
    portfolioPerformanceSaga,
  );
  yield takeLatest(
    jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_CHART_SAGA,
    portfolioChartSaga,
  );
  yield takeLatest(
    jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_SECTOR_SAGA,
    portfolioSectorSaga,
  );
  yield takeLatest(
    jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_MARKET_SAGA,
    portfolioMarketSaga,
  );

  yield takeLatest(
    jarvisPrimeDashboardConstants.CUSTOMER_STORIES_SAGA,
    customerStoriesListSaga,
  );
  yield takeLatest(
    jarvisPrimeDashboardConstants.WELCOME_VIDEO_SAGA,
    welcomeVideoListSaga,
  );
  yield takeLatest(
    jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALERT_SAGA,
    portfolioAlertSaga,
  );
  yield takeLatest(
    jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PENDING_TRANSACTION_SAGA,
    portfolioPendingTransactionSaga,
  );

  yield takeLatest(
    jarvisPrimeDashboardConstants.DASHBOARD_REFRESH_SAGA,
    dashboardRefreshSaga,
  );
}
